export const ROLE_CLAIM = {
  admin: 'admin',
  editor: 'editor',
  viewer: 'viewer',
} as const;

export const ALL_CLAIM_ROLES = [ROLE_CLAIM.admin, ROLE_CLAIM.editor, ROLE_CLAIM.viewer];
